import Typography from "@material-ui/core/Typography";
import { FormattedMessage } from "react-intl";
import { PrivacyPolicyLink, SoftwareTermsOfUseLink } from "../common";

export const DefaultPrivacyPolicy = () => {
  return (
    <Typography variant="body1" data-testid="privacyPolicy.default">
      <FormattedMessage
        id="first-sign-in.default.privacyTerms"
        defaultMessage="Elephant must process your personal information in order to set up your professional user account. Your personal information will be processed in accordance with Elephant’s {PrivacyPolicyLink}. By using Elephant, you agree to our {SoftwareTermsOfUseLink}."
        values={{
          PrivacyPolicyLink: <PrivacyPolicyLink />,
          SoftwareTermsOfUseLink: <SoftwareTermsOfUseLink />,
        }}
      />
    </Typography>
  );
};
